import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { AntiguedadSaldos } from "./form";
import { FiltroCliente } from "app/models/requireme";
const AntiguedadSaldosFormRx = componentToRx(AntiguedadSaldos);

type Entity = models.FiltroAntiguedadSaldos;
const resource = resources.AntiguedadSaldos;

export interface State {
    value: Entity;
}

const user = resources.User.SessionRx;
const idClienteFiltro = user.map(x => x.Permisos.Reportes.VerTodosClientesReportes ? null : x.IdCliente);
const clienteFiltro = idClienteFiltro.map<number | null,|FiltroCliente>(x => ({
    IdRegistro: x
}));


class AntguedadSaldosEditComp extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    get rules(): validation.Rules<Entity> {
        return {
            FechaCorte: validation.required
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);

    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x }, () => console.log(this.state))
    }), this.errors);

   // onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onGenerarAntiguedadSaldos = async () => {
        const reporte = await resources.AntiguedadSaldos.GenerarReporteAntiguedad(this.state.value);
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte de antiguedad de saldos.xls");
    }

    componentWillMount = async() => {
       var uuu = await user.first().toPromise();
       this.setState( {
        value: {IdCliente : uuu.IdCliente} as Entity
        } );
    }

    render() {

        var ClienteVerBotones = this.state.value.IdCliente == null
        console.log(this.state.value)
        console.log(ClienteVerBotones);
        

            const getField = this.getField;
            const Sucursal = getField(selectores.Sucursal);
            const Cliente = getField(selectores.Cliente);
            const Vendedor = getField(selectores.Vendedor);
            const DateTime = getField(kea.DateTime);

            return (
                <div>
                    <kea.Title titulo="Antigüedad de saldos" onRegresar={() => history.go("../")} />
                    {kea.autogrid(6, [
                        <DateTime field="FechaCorte" label="Fecha de Corte:" />,
                        <Sucursal field="IdSucursalCobranza" label="Sucursal de cobranza:" />,
                        ClienteVerBotones &&<Cliente  field="IdCliente" label="Cliente:" filtro={clienteFiltro} />,
                        <Vendedor field="IdVendedor" label="Vendedor:" />
                    ])}
    
                    <div className="row">
                        <div className="col-md-12">
                            {/* <kea.Button children="Genrar reporte" onClick={this.onGenerar} style="success" /> */}
                            <kea.Button children="Antigüedad Saldos" style="success" onClick={this.onGenerarAntiguedadSaldos} disabled={validation.hasError(this.errors())} />
                        </div>
                    </div>
                </div>);
    }
}

export const AntguedadSaldosEdit = withRouter(AntguedadSaldosEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteantiguedadsaldos/edit/edit.tsx